var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrintingIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "406px",
    height: "610px",
    viewBox: "0 0 406 610",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "printing-illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Printing-xxl-1440-.container-lg",
    transform: "translate(-959, -565)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "printing-illustration",
    transform: "translate(959, 565)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F8B588",
    opacity: 0.200000003,
    x: 274.462747,
    y: 337.943927,
    width: 24.2722158,
    height: 24.2722158,
    rx: 6.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F8B588",
    x: 311.804618,
    y: 341.678114,
    width: 33.6076834,
    height: 5.60128056,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-19",
    fill: "#F8B588",
    opacity: 0.200000003,
    x: 311.804618,
    y: 356.614862,
    width: 24.2722158,
    height: 5.60128056,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-20",
    fill: "#F8B588",
    opacity: 0.200000003,
    x: 311.804618,
    y: 349.146488,
    width: 46.677338,
    height: 5.60128056,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-18",
    stroke: "#000000",
    strokeWidth: 2,
    x: 264.260186,
    y: 288.532402,
    width: 138.032014,
    height: 85.7533955
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-16",
    stroke: "#000000",
    strokeWidth: 2,
    x: 1,
    y: 288.532402,
    width: 201.513194,
    height: 313.538805
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 7.46837408,
    y: 7.46837408,
    width: 289.399496,
    height: 212.848661
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.50972196,
    y1: 281.710459,
    x2: 9.50972196,
    y2: 293.546934,
    id: "Path-10",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.5793766,
    y1: 281.710459,
    x2: 22.5793766,
    y2: 293.546934,
    id: "Path-10-Copy",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.6490312,
    y1: 281.710459,
    x2: 35.6490312,
    y2: 293.546934,
    id: "Path-10-Copy-2",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.7186859,
    y1: 281.710459,
    x2: 48.7186859,
    y2: 293.546934,
    id: "Path-10-Copy-3",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.7883405,
    y1: 281.710459,
    x2: 61.7883405,
    y2: 293.546934,
    id: "Path-10-Copy-4",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 74.8579952,
    y1: 281.710459,
    x2: 74.8579952,
    y2: 293.546934,
    id: "Path-10-Copy-5",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.9276498,
    y1: 281.710459,
    x2: 87.9276498,
    y2: 293.546934,
    id: "Path-10-Copy-6",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.997304,
    y1: 281.710459,
    x2: 100.997304,
    y2: 293.546934,
    id: "Path-10-Copy-7",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.066959,
    y1: 281.710459,
    x2: 114.066959,
    y2: 293.546934,
    id: "Path-10-Copy-8",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 127.136614,
    y1: 281.710459,
    x2: 127.136614,
    y2: 293.546934,
    id: "Path-10-Copy-9",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.206268,
    y1: 281.710459,
    x2: 140.206268,
    y2: 293.546934,
    id: "Path-10-Copy-10",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 153.275923,
    y1: 281.710459,
    x2: 153.275923,
    y2: 293.546934,
    id: "Path-10-Copy-11",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 166.345578,
    y1: 281.710459,
    x2: 166.345578,
    y2: 293.546934,
    id: "Path-10-Copy-12",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 179.415232,
    y1: 281.710459,
    x2: 179.415232,
    y2: 293.546934,
    id: "Path-10-Copy-13",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192.484887,
    y1: 281.710459,
    x2: 192.484887,
    y2: 293.546934,
    id: "Path-10-Copy-14",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-11",
    stroke: "#000000",
    strokeWidth: 2,
    points: "203.513194 293.546934 209.866112 293.546934 209.866112 609 8.5761752 609 8.5761752 603.071207"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 22.4051222,
    y: 309.937524,
    width: 158.702949,
    height: 156.835856,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-21",
    fill: "#F8B588",
    x: 28.0064028,
    y: 435.03279,
    width: 24.2722158,
    height: 24.2722158,
    rx: 6.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-22",
    fill: "#F8B588",
    x: 283.798215,
    y: 156.835856,
    width: 106.424331,
    height: 5.60128056,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-23",
    fill: "#F8B588",
    opacity: 0.200000003,
    x: 283.798215,
    y: 166.171323,
    width: 87.7533955,
    height: 5.60128056,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-24",
    fill: "#F8B588",
    opacity: 0.200000003,
    x: 283.798215,
    y: 205.380287,
    width: 98.9559566,
    height: 5.60128056,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-17",
    stroke: "#000000",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 403.159294,
    height: 225.785409
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintingIllustration);
export default __webpack_public_path__ + "static/media/printing-illustration.22589e6cf2beeedd412bd9ac2e7211a1.svg";
export { ForwardRef as ReactComponent };